export function xRayEntityAction() {
  const { t } = useI18n();

  return {
    getTitle: () => t('components.xeokit_viewer.context_menu.x_ray') || 'X-Ray',
    getEnabled: function (context) {
      return !context.entity.xrayed;
    },
    doAction: function (context) {
      context.entity.xrayed = true;
    },
  };
}
